import type { UrlState } from './types';

export const INITIAL_URL_STATE: UrlState = {
  viewMode: 'tiles',
  sort: 'last_updated',
  query: '',
};
export const ALL_ENTITIES = ['demo', 'record', 'tour', 'playbook'];
export const SHARED_FOLDER_ENTITIES = ['demo', 'tour', 'playbook'];
